import { removeElementStyleAttribute, setElementStyleAttribute, sleep } from "../lib/utils.js"

class FFSearch {
  DOM: {
    trigger: HTMLElement | null
    close: HTMLElement | null
    form: HTMLElement | null
    input: HTMLInputElement | null
  }
	
	constructor (){
		this.DOM = {
			trigger: document.querySelector('#js-search-open'),
			close: document.querySelector('#js-search-close'),
			form: document.querySelector('#ff-header-panel-search'),
			input: document.querySelector('#ff-header-panel-search input[name="q"]'),
		}
		this.events();
	}

	events(){
		this.DOM.trigger?.addEventListener( 'click', this.open.bind(this) );
		this.DOM.close?.addEventListener( 'click', this.close.bind(this) );
	}

	async open (e: MouseEvent){
		if( window.innerWidth <= 1024 ) return
		e.preventDefault();
		setElementStyleAttribute(this.DOM.form, "z-index", "3")
		setElementStyleAttribute(this.DOM.form, "display", "block")
		await sleep(10)
		setElementStyleAttribute(this.DOM.form, "opacity", "1")
		this.DOM.input?.focus();
	}

	async close (){
		removeElementStyleAttribute(this.DOM.form, "opacity")
		await sleep(300)
		removeElementStyleAttribute(this.DOM.form, "display")
		removeElementStyleAttribute(this.DOM.form, "z-index")
	}
}
new FFSearch();